import React from "react";
import styles from "./style.module.scss";
import MeetUsWrapper from "Components/MeetUsWrapper";
import MVRStakingImage from "../../../Utils/Assets/Images/MVRStakingImage.png";
import coin from "../../../Utils/Assets/Images/coin.png";

const MVRStakingSection = () => {
    return (
        <div className={styles.stakingSection}>
            <MeetUsWrapper>
                <div className={styles.stakingWrapper}>
                    <div className={styles.stakingCard}>
                        <div
                            className={styles.stakingImageWrapper}
                            data-aos="fade-right"
                            data-aos-duration="800"
                            data-aos-once="false"
                        >
                            <img
                                src={MVRStakingImage}
                                alt="Staking Placeholder"
                                className={styles.stakingMainImage}
                            />
                        </div>

                        <div
                            className={styles.stakingContent}
                            data-aos="fade-left"
                            data-aos-duration="800"
                            data-aos-once="false"
                        >
                            <div className={styles.stakingCoinGroup}>
                                <img
                                    src={coin}
                                    alt="Coin"
                                    className={styles.stakingCoinBack}
                                />
                                <img
                                    src={coin}
                                    alt="Coin"
                                    className={styles.stakingCoinFront}
                                />
                            </div>

                            <button className={styles.stakingHeaderButton}>
                                MVR Wealth Coin{" "}
                            </button>

                            <div className={styles.stakingTextWrapper}>
                                <h1 className={styles.stakingTitle}>
                                    Grow Your Wealth with MVR Staking
                                </h1>
                                <p className={styles.stakingDescription}>
                                    MVR Staking offers a secure and rewarding
                                    way to grow your digital assets
                                    effortlessly. Start staking today!
                                </p>
                            </div>

                            <button className={styles.stakingButton}>
                                Earn Your Coins Now
                            </button>
                        </div>
                    </div>
                </div>
            </MeetUsWrapper>
        </div>
    );
};

export default MVRStakingSection;
